import { format } from 'date-fns';
import React from 'react';
import { api_auth, api_host } from '../../../common/globals/constants';
import { getApiKeys } from '../../../utils/fns/get-api-keys';

export function useDisponibilidadConsolidadaEspecialPichincha({
  objetivoId,
  fechaInicio,
  fechaTermino,
}) {
  const [data, setData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [isSuccess, setIsSuccess] = React.useState(false);

  React.useEffect(() => {
    if (!objetivoId) {
      return;
    }
    fetchData();
  }, [objetivoId, fechaInicio, fechaTermino]);

  function refetch() {
    fetchData();
  }

  async function fetchData() {
    setIsLoading(true);
    setIsSuccess(false);
    const { token, user: userId } = getApiKeys()
    const inicio = format(fechaInicio, 'yyyy-MM-dd');
    const termino = format(fechaTermino, 'yyyy-MM-dd');
    try {
      const response = await fetch(
        `${api_host}/reporte/online/indicadores/calculoDisponibilidadPichincha/?user=${userId}&horarioId=0&key=${api_auth}&nodoId=0&objetivoId=${objetivoId}&t=c&token=${token}&fechaInicio=${inicio}&fechaTermino=${termino}&fecha=${new Date().getTime()}`
      );
      if (!response.ok) {
        throw new Error('Error al obtener la configuración');
      }
      const myJson = await response.json();
      setData(myJson);
      setIsSuccess(true);
      setIsError(false);
    } catch (e) {
      console.error(e);
      setIsError(true);
      setIsSuccess(false);
    } finally {
      setIsLoading(false);
    }
  }

  return {
    data,
    isLoading,
    isError,
    isSuccess,
    refetch,
  };
}
